appHost.actions.register({
    // #region Vars
    name: '288a.system.window.close',
    // #endregion
    // #region Entry
    async execute(data, params) {
        if (!params.__component) {
        }
        //Run
        this.$appHost.router.closeCurrentWindow(params.__component);
        //Finish
        return { isSucceeded: true };
    },
    // #endregion
});
export {};
